// auth.service.ts
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DestinosData, IDestinosAPIResponse, IDestinosSimpleAPIResponse } from '../../models/web/IDestinos';
import { ISimpleDestino } from '../../models/web/ISimpleDestino';
import { AuthWebService } from './auth-web.service';

@Injectable({
	providedIn: 'root'
})
export class GetDestinosWebService {
	private http = inject(HttpClient);
	private authService = inject(AuthWebService);
	token = this.authService.obtenerToken();
	getDestinos(params: { [key: string]: any }): Observable<IDestinosAPIResponse> {
		let httpParams = new HttpParams();
		Object.keys(params).forEach((key) => {
			if (params[key]) {
				if (Array.isArray(params[key])) {
					params[key].forEach((value: string) => {
						httpParams = httpParams.append(key, value);
					});
				} else {
					httpParams = httpParams.set(key, params[key]);
				}
			}
		});
		const headers = new HttpHeaders({
			Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
			'Content-Type': 'application/json'
		});
		return this.http.get<IDestinosAPIResponse>(`${environment.apiWebUrl}/destinos`, { headers, params: httpParams });
	}
	getDestino(slug: string): Observable<DestinosData> {
		const headers = new HttpHeaders({
			Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
			'Content-Type': 'application/json'
		});
		return this.http.get<DestinosData>(`${environment.apiWebUrl}/destinos/${slug}`, { headers });
	}

	getPrincipalesDestinos(): Observable<DestinosData[]> {
		const headers = new HttpHeaders({
			Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
			'Content-Type': 'application/json'
		});
		return this.http.get<DestinosData[]>(`${environment.apiWebUrl}/destinos-destacados`, { headers });
	}
}
